import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
var CaseTypes = {
    CAPITALIZE: 'capitalize',
    LOWER_CASE: 'lowerCase',
    UPPER_CASE: 'upperCase',
    NO_FORMAT: ''
};
var setTextCase = function (text, caseType) {
    switch (caseType) {
        case CaseTypes.CAPITALIZE:
            return "".concat(text[0].toUpperCase()).concat(text.slice(1).toLowerCase());
        case CaseTypes.LOWER_CASE:
            return text.toLowerCase();
        case CaseTypes.UPPER_CASE:
            return text.toUpperCase();
        case CaseTypes.NO_FORMAT:
        default:
            return text;
    }
};
var PluralText = function (_a) {
    var 
    // NB: we must rename "case" when it converts from a prop to a variable because
    // "case" is a reserved word in JS
    caseType = _a["case"], quantity = _a.quantity, shouldIncludeQuantity = _a.shouldIncludeQuantity, text = _a.text, props = __rest(_a, ["case", "quantity", "shouldIncludeQuantity", "text"]);
    // The 3rd argument of the `pluralize` library ("inclusive") will prefix the
    // number to the pluralized text for us... but it does not format the number,
    // so we'll prepend manually instead. The trailing space is significant.
    var formattedQuantity = "".concat(quantity === null || quantity === void 0 ? void 0 : quantity.toLocaleString(), " ");
    var casedText = setTextCase(text, caseType);
    return (React.createElement("span", __assign({}, props),
        shouldIncludeQuantity ? formattedQuantity : null,
        pluralize(casedText, quantity)));
};
PluralText.defaultProps = {
    quantity: 0,
    shouldIncludeQuantity: false
};
PluralText.propTypes = {
    "case": PropTypes.oneOf(Object.values(CaseTypes)),
    quantity: PropTypes.number,
    shouldIncludeQuantity: PropTypes.bool,
    text: PropTypes.string.isRequired
};
export default PluralText;
//# sourceMappingURL=PluralText.js.map